<script lang="ts">
    import {  Col } from "sveltestrap";
    import Card from "../UiCommenCard.svelte";
    import data from "../../../Data/ComponentData/Ui-kits/Typography/Headings.json";
    import { Heading } from "../../../utils/Constant/Constant";
</script>

{#each data.Fontthin as Item}
    <Col sm="12" xl="4">
        <Card cardHeaderprops="pb-0" headerTitle={Item.headers} CardBodyprops="typography">
            <div slot="contentbody">
                <h1 class={Item.class}>{Heading} 1</h1>
                <h2 class={Item.class}>{Heading} 2</h2>
                <h3 class={Item.class}>{Heading} 3</h3>
                <h4 class={Item.class}>{Heading} 4</h4>
                <h5 class={Item.class}>{Heading} 5</h5>
                <h6 class={Item.class}>{Heading} 6</h6>
            </div>
        </Card>
    </Col>
{/each}
